<template>
	<div class="layer-project" data-project-name="d-steady">
		<!-- Project Name -->
		<div class="layer-project-detail">
			<!-- Page Contents -->
			<section class="project-visual">
				<div>
					<h1 class="project-tit">
						<span class="award14"></span><em>D.Steady</em> Mall
					</h1>
					<a href="http://www.d-steady.com" class="link" target="_blank"
						>www.d-steady.com</a
					>
				</div>
			</section>
			<!-- Details [s] -->
			<section class="project-overview">
				<div class="inner-section">
					<h2 class="project-overview-tit">Overview</h2>
					<p class="project-overview-txt">
						1일 1팩이라는 컨셉으로 제작된 마스크팩 D.Steay는 개인의 피부 타입에
						맞춘 체계적인 마스크팩으로 정기배송을 통해 매일 집에서 피부 케어를
						받을 수 있는 제품의 특성을 바탕으로,
						<span
							>편안함과 휴식 느낌의 뉴트럴 계열 컬러와 패키지 형태의 육각형을
							그래픽 모티브로 활용하여 사이트를 제작했습니다.</span
						>
					</p>
					<div class="project-overview-diagram clfix">
						<p class="diagram01">The Value of small change</p>
						<div class="diagram02">
							<ul>
								<li class="item01"><span>Amore Pacific</span></li>
								<li class="item02"><span>Mask Pack</span></li>
								<li class="item03"><span>D.Steady</span></li>
							</ul>
						</div>
						<p class="diagram03">Daily Skin Home Care</p>
					</div>
				</div>
			</section>
			<section class="section section01">
				<div class="inner-section">
					<strong
						>BRAND <br />SHOPPING <br />SUBSCRIPTION <br />EVENT <br />STORY
					</strong>
					<p class="sub-text">
						Daily and Steadily, the value of small change<br />
						Meet STEADY BOX simply in your daily life.
					</p>
				</div>
			</section>
			<section class="section full section02">
				<div class="inner-section">
					<div class="pc-web-info">
						<h2 class="project-subtit">PC Web</h2>
						<p class="sub-text">
							상단 키비주얼 영역에서 처음만나는 브랜드와 제품의 이미지를
							부각시킬 수 있도록 하였고, 콘텐츠의 내용은 제품의 특징에 대한
							설명을 제품의 사진과 함께 시각적으로 이해가 쉽도록 구성하였습니다.
							<br />제품 파우치의 육각형 형태를 그래픽 모티브로 활용하여
							제품패키지의 룩과 콘텐츠의 룩이 일치되어 보이도록 하였습니다.
						</p>
					</div>
					<div class="img pc-web-info">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/d-steady/pc-web-img-01@m.png"
						/>
					</div>

					<div class="img">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/d-steady/pc-web-img-02@m.png"
						/>
					</div>
				</div>
			</section>
			<section class="section section03">
				<div class="inner-section">
					<h2 class="project-subtit">Mobile Web</h2>
					<div class="img">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/d-steady/mobile-web-img-01@m.png"
						/>
					</div>
				</div>
			</section>
			<section class="section section04">
				<div class="inner-section">
					<div class="point-font-area">
						<div class="img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/d-steady/point-font-img@m.png"
							/>
						</div>
					</div>
					<div class="point-icon-area">
						<div class="img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/d-steady/point-icon-img@m.png"
							/>
						</div>
					</div>
				</div>
			</section>
			<!-- Details [e] -->
			<section class="project-client">
				<strong class="a11y-hidden">D.Steady Mall</strong>
			</section>
			<!-- Page Contents -->
		</div>

		<app-pjmove></app-pjmove>
	</div>
</template>

<script>
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();
	},
	methods: {},
};
</script>
<!-- css 추가 -->
<style>
@import "../../static/css/projects.css"; /* Common Project Detail Page */
</style>
<style scoped>
/* Common */
.sub-text {
	word-break: keep-all;
}
.img {
	text-align: center;
}

/* Project Visual, Project CI */
.project-client {
	background: url(/static/img/project-detail/d-steady/ci.png) 50% / auto 29px
		no-repeat;
}
@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/d-steady/bg-overview@m.jpg);
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/d-steady/bg-overview@t.jpg);
	}
	.project-client {
		background-size: auto 45.5px;
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/d-steady/bg-overview@w.jpg);
	}
	.project-client {
		background-size: auto 91px;
	}
}

/* Overview */
.project-overview {
	background-color: #a786e0;
	color: #fff;
}
.project-tit em {
	font-weight: inherit;
	text-transform: uppercase;
}
.project-overview-txt {
	margin-bottom: 30px;
}
.project-overview-diagram {
	text-align: center;
}
.project-overview-diagram .diagram02 {
	position: relative;
	padding-top: 40px;
	padding-bottom: 40px;
}
.project-overview-diagram .diagram02:before {
	content: "";
	position: absolute;
	top: 10px;
	left: 50%;
	width: 1px;
	height: 20px;
	background-color: #fff;
}
.project-overview-diagram .diagram02:after {
	content: "";
	position: absolute;
	bottom: 10px;
	left: 50%;
	width: 1px;
	height: 20px;
	background-color: #fff;
}
.project-overview-diagram ul {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;
}
.project-overview-diagram li {
	background: url(/static/img/project-detail/d-steady/diagram-bg-w.png)
		no-repeat;
	background-size: 100% auto;
}
.project-overview-diagram li span {
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	width: 94px;
	height: 54px;
	margin: 27px 0;
	padding: 15px;
	color: #222;
}

.project-overview-diagram .item01 {
	margin-right: -8px;
}
.project-overview-diagram .item02 {
	margin-left: -8px;
}
.project-overview-diagram .item03 {
	position: relative;
	margin: 0 30%;
	padding-top: 52px;
	background-image: url(/static/img/project-detail/d-steady/diagram-bg.png);
	background-position-y: 100%;
}
.project-overview-diagram .item03:before {
	content: "";
	position: absolute;
	left: calc(50% - 8px);
	top: 20px;
	width: 15px;
	height: 15px;
	border-right: 1px solid #fff;
	border-bottom: 1px solid #fff;
	transform: rotate(45deg);
}
.project-overview-diagram .item03 span {
	text-transform: uppercase;
	color: #fff;
}

@media screen and (min-width: 712px) {
	.project-overview-diagram {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: center;
	}
	.project-overview-diagram .diagram01 {
		width: 85px;
		text-align: left;
	}
	.project-overview-diagram .diagram02 {
		padding-top: 0;
		padding-bottom: 0;
		padding-left: 82px;
		padding-right: 77px;
	}
	.project-overview-diagram .diagram02:before {
		top: 50%;
		left: 15px;
		width: 48px;
		height: 1px;
	}
	.project-overview-diagram .diagram02:after {
		top: 50%;
		bottom: auto;
		left: auto;
		right: 15px;
		width: 48px;
		height: 1px;
	}
	.project-overview-diagram .item03 {
		margin: 0;
		padding-top: 0;
		padding-left: 45px;
		background-position: 100% 100%;
		background-size: auto 100%;
	}
	.project-overview-diagram .item03:before {
		top: calc(50% - 8px);
		left: 10px;
		transform: rotate(-45deg);
	}
	.project-overview-diagram .diagram03 {
		width: 70px;
	}
}
@media screen and (min-width: 1280px) {
	.project-overview-txt span {
		display: block;
	}
	.project-overview-diagram {
		font-size: 18px;
	}
	.project-overview-diagram .diagram01 {
		width: 110px;
	}
	.project-overview-diagram .diagram02 {
		padding-left: 195px;
		padding-right: 210px;
	}
	.project-overview-diagram .diagram02:before {
		top: calc(50% - 1px);
		left: 27px;
		width: 136px;
		height: 2px;
	}
	.project-overview-diagram .diagram02:after {
		top: calc(50% - 1px);
		right: 20px;
		width: 156px;
		height: 2px;
	}
	.project-overview-diagram .item01 {
		margin-right: -10px;
	}
	.project-overview-diagram .item02 {
		margin-left: -10px;
	}
	.project-overview-diagram .item03 {
		padding-left: 91px;
	}
	.project-overview-diagram .item03:before {
		top: calc(50% - 15px);
		left: 15px;
		width: 30px;
		height: 30px;
		border-width: 2px;
	}
	.project-overview-diagram li {
		background-position: 50%;
		background-size: auto auto;
	}
	.project-overview-diagram li span {
		width: 188px;
		height: 108px;
		margin: 94px 0;
		font-size: 20px;
	}
	.project-overview-diagram .item03 {
		background-position: 100% 50%;
		background-size: auto auto;
	}
	.project-overview-diagram .item03 span {
		font-size: 28px;
	}
	.project-overview-diagram .diagram03 {
		width: 90px;
	}
}

.section01 {
	min-height: 114.53125vw;
	color: #fff;
	background: url(/static/img/project-detail/d-steady/brand-bg@m.png) no-repeat;
	background-size: cover;
}
.section01 strong {
	display: block;
	margin-bottom: 25px;
	font-size: 4rem;
	font-weight: 500;
	line-height: 1.2;
}
@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
	.section01 {
		min-height: 49.789325vw;
		background-image: url(/static/img/project-detail/d-steady/brand-bg@t.png);
	}
}
@media screen and (min-width: 1280px) {
	.section01 {
		min-height: 724px;
		background-image: url(/static/img/project-detail/d-steady/brand-bg@w.png);
	}
	.section01 .inner-section {
		padding-top: 60px;
	}
	.section01 strong {
		margin-bottom: 55px;
		font-size: 80px;
		line-height: 90px;
	}
	.section01 .sub-text {
		font-size: 18px;
		line-height: 28px;
	}
}
.section.section02 {
	padding-bottom: 0;
	background-color: #e6e6e6;
}
.pc-web-info {
	padding: 0 15px;
}
.section02 .project-subtit {
	line-height: 1;
}
.section02 .sub-text {
	margin-bottom: 30px;
}
.pc-web-info.img {
	margin-bottom: 30px;
}
.pc-web-info.img img {
	box-shadow: 0 35px 30px rgba(0, 0, 0, 0.1);
}
@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
	.section02 .sub-text {
		font-size: 1.6rem;
	}
	.pc-web-info {
		padding: 0 40px;
	}
	.pc-web-info.img {
		margin-bottom: 76px;
		padding: 0 68px;
	}
}
@media screen and (min-width: 1280px) {
	.section02 .sub-text {
		font-size: 15px;
	}
	.pc-web-info {
		max-width: 1280px;
		margin: 0 auto;
		padding: 0 20px;
	}
	.pc-web-info.img {
		margin-bottom: 176px;
		padding: 0 20px;
	}
}
.section03 {
	background-color: #e6e6e6;
}
@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
	.section03 .inner-section {
		position: relative;
		padding-top: 70px;
	}
	.section03 .project-subtit {
		position: absolute;
		top: 35px;
		left: 0;
	}
}
@media screen and (min-width: 1280px) {
	.section03 .inner-section {
		max-width: 1440px;
		padding-top: 90px;
		padding-left: 0;
		padding-right: 0;
	}
	.section03 .project-subtit {
		left: calc(50% - 620px);
	}
}
.section04 {
	position: relative;
	background-color: #222;
}
.section04:before {
	content: "";
	position: absolute;
	top: -40px;
	left: 50%;
	width: 1px;
	height: 80px;
	background-color: #9990b6;
}
.section04 .inner-section {
	padding-top: 40px;
	padding-bottom: 40px;
}
.point-font-area {
	margin-bottom: 40px;
}
.point-font-area .img {
	width: 89.6875vw;
}
.point-icon-area img {
	width: 76.25vw;
}
@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
	.section04:before {
		top: -50px;
		height: 100px;
	}
	.section04 .inner-section {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		align-items: center;
	}
	.point-font-area .img {
		width: 43.8202vw;
	}
	.point-icon-area .img {
		text-align: right;
	}
	.point-icon-area img {
		width: 34.2696vw;
	}
}
@media screen and (min-width: 1280px) {
	.section04 .inner-section {
		padding-top: 180px;
		padding-bottom: 147px;
	}
	.point-font-area .img {
		width: 624px;
	}
	.point-icon-area img {
		width: 488px;
	}
}
</style>



// WEBPACK FOOTER //
// src/projects/d-steady.vue